export default {
  title: 'Push Notifications',
  description: 'Send targeted push notifications to your customers',
  buttons: {
    new_campaign: 'New Campaign',
  },
  error_messages: {
    no_mobile_app: {
      title: 'Mobile App not live yet',
      description: 'Please wait for the mobile app to be live before you can send push notifications',
    },
  },
};
